import { useEffect, useRef } from "react";

const ALL_SYMBOLS = ["🍒", "💎", "⭐", "🔔", "🍋", "7"];

function Reel({ symbol, spinning, delay }) {
  const stripRef = useRef(null);

  // Generate a long random strip ending with the result symbol
  const strip = [];
  for (let i = 0; i < 20; i++) {
    strip.push(ALL_SYMBOLS[Math.floor(Math.random() * ALL_SYMBOLS.length)]);
  }
  strip.push(symbol);

  useEffect(() => {
    if (!stripRef.current) return;
    if (spinning) {
      stripRef.current.style.transition = "none";
      stripRef.current.style.transform = "translateY(0)";
      // Force reflow
      void stripRef.current.offsetHeight;
      const totalHeight = (strip.length - 1) * 100; // percentage based; height of each symbol
    }
  }, [spinning, strip.length]);

  return (
    <div className="reel-window flex-1 h-24 sm:h-28">
      <div
        ref={stripRef}
        className={`reel-strip ${spinning ? "spinning" : ""}`}
        style={
          spinning
            ? { animationDelay: `${delay}ms`, animationDuration: "0.1s" }
            : {}
        }
      >
        <div className="symbol">{symbol}</div>
      </div>
    </div>
  );
}

export default function SlotMachine({ reels, spinning, won }) {
  return (
    <div className={`flex gap-2 sm:gap-3 ${won && !spinning ? "win-flash gold-border" : ""} p-2 rounded-xl`}>
      {reels.map((s, i) => (
        <Reel key={i} symbol={s} spinning={spinning} delay={i * 150} />
      ))}
    </div>
  );
}
